/*
 * @@Author: MuYang
 */

import batchHandleUrl from '../../utils/url-handle'

const Api = {
  getPageRule: {
    url: '/apaas/rule/getPageRule',
    type: 'POST'
  },
  getRuleValue: {
    url: '/apaas/object/value/get/ruleValue',
    type: 'POST'
  },
  // 获取对象 schema
  getLayoutInfo: {
    url: '/apaas/layout/get',
    type: 'post'
  },
  // 查找关联主从列设置
  getRelationLayoutDetail: {
    url: '/apaas_design/layout/getRelationLayoutDetail',
    type: 'post'
  },
  print: {
    url: '/apaas/print',
    type: 'get'
  }
}

export default batchHandleUrl(Api)
